export enum SearchSortField {
  PublishedAt = 'publishedAt',
  Score = 'score',
}
